export const status = {
    'active': 'Looking for a driver',
    'waiting for payment': 'Waiting for payment',
    'driver matched': 'Driver matched',
    'driver on the way': 'Driver on the way',
    'picked up': 'Item picked up',
    'delivery in progress': 'Delivery in progress',
    'completed': 'Completed',
    'canceled': 'Canceled'
};

export const customerCancelReason = {
    'active': [
        'Waiting for too long',
        'No need the service',
    ],
    'waiting for payment': [
        'No need the service',
        'Too expensive',
    ],
    'driver matched': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'driver on the way': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'picked up': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'delivery in progress': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ]
};

export const driverCancelReason = {
    'active': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'waiting for payment': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'driver matched': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'driver on the way': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'picked up': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'delivery in progress': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ]
};